import { put, takeLatest,takeEvery } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
  handleNotificationAlertTryUpdate,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectPortfolidetail: "[selectPortfoliodetail] Action",
  selectPortfolidetailLoad: "[selectPortfoliodetailLoad] Action",
  selectPortfolidetailAsc: "[selectPortfoliodetailAsc] Action",
  selectPortfolidetailDesc: "[selectPortfoliodetailDesc] Action",
  selectPortfoliodetailAsync: "[selectPortfoliodetailAsync] Action",
};

const initialState = {
  data: [],
  dataSortAsc: [],
  dataSortDesc: [],
  loading:false
};

export const select_portfolio_detail_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectPortfolidetail:
      return {
        ...state,
        data: payload?.data?.results ? payload?.data?.results : [],
      };
    case actionTypes.selectPortfolidetailAsc:
      return {
        ...state,
        dataSortAsc: payload?.data?.results ? payload?.data?.results : [],
      };
    case actionTypes.selectPortfolidetailDesc:
      return {
        ...state,
        dataSortDesc: payload?.data?.results ? payload?.data?.results : [],
      };
    case actionTypes.selectPortfolidetailLoad:
      return {
        ...state,
       loading:payload
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectPortfolidetailLoad, payload: true });
  let config = {
    url: "select_request",
  };
  


  let data = {
    table: "portfolio",
    method_type: "select_portfolio_detail",
    data: payload.data ? payload.data : {},
    sort_by: payload.sort ? payload.sort : {},
  };

  try {
    let res = yield AxiosCustom(config, data);


    if (payload?.sort?.return === "desc") {
      yield put({
        type: actionTypes.selectPortfolidetailDesc,
        payload: res.data.response,
      });
    }
    if (payload?.sort?.return === "asc") {
      yield put({
        type: actionTypes.selectPortfolidetailAsc,
        payload: res.data.response,
      });
    }

    if (!payload?.sort) {
      yield put({
        type: actionTypes.selectPortfolidetail,
        payload: res.data.response,
      });
    }

    if(payload == {}){
      yield put({
        type: actionTypes.selectPortfolidetail,
        payload: res.data.response,
      });
    }
  } catch {
    handleNotificationAlertCatch();
    // yield put({ type: actionTypes.creaditSelectLoad, payload: false });
  }finally{
    yield put({ type: actionTypes.selectPortfolidetailLoad, payload: false });
  }
}

export function* selectPortfoliodetail() {
  yield takeEvery(actionTypes.selectPortfoliodetailAsync, handleWorker);
}
